import Image from "next/image"
import React from "react"

import PlaceholderImage from "@modules/common/icons/placeholder-image"
import { CartDetails } from "@modules/signup-and-order-flow/util/use-create-cart"

import NeloBackgroundContainer from "./nelo-background-container"

interface OrderSummaryProps {
  cartDetails: CartDetails | null
}

const OrderSummary: React.FC<OrderSummaryProps> = ({ cartDetails }) => {
  if (!cartDetails || !cartDetails.productTotalBreakdown || !cartDetails.productTotalBreakdown.total) {
    return null
  }

  const { productTotalBreakdown, productDetails } = cartDetails

  const thumbnail = productDetails?.thumbnail ? (
    <Image
      src={productDetails.thumbnail}
      alt={productDetails.name}
      width={80}
      height={80}
      className="aspect-square rounded-md border border-gray-200 object-cover"
    />
  ) : (
    <PlaceholderImage size={80} />
  )

  return (
    <NeloBackgroundContainer title="Detalles del pedido">
      <div className="space-y-2">
        <div className="mb-4 flex items-center justify-start gap-2">
          {thumbnail}
          <div className="flex w-1/2">
            <p className="line-clamp-2 font-manrope font-bold">{productDetails?.name}</p>
          </div>
        </div>
        <div className="flex justify-between">
          <span className="font-nunito">Subtotal</span>
          <span className="font-nunito">${productTotalBreakdown.subTotal?.toFixed(2)}</span>
        </div>
        <div className="flex justify-between">
          <span className="font-nunito">Envío y manejo</span>
          <span className="font-nunito">${productTotalBreakdown.shippingTotal?.toFixed(2)}</span>
        </div>
        {typeof productTotalBreakdown.discountTotal !== "undefined" && productTotalBreakdown.discountTotal !== 0 && (
          <div className="flex justify-between">
            <span className="font-nunito">Descuento</span>
            <span className="font-nunito text-red-500">-${productTotalBreakdown.discountTotal.toFixed(2)}</span>
          </div>
        )}
        <div className="flex justify-between border-t pt-2 font-semibold">
          <span className="font-nunito">Total</span>
          <span className="font-nunito">${productTotalBreakdown.total?.toFixed(2)}</span>
        </div>
      </div>
    </NeloBackgroundContainer>
  )
}

export default OrderSummary
